import { MenuItem } from '@chakra-ui/react'
import { FC } from 'react'
import { GrDocumentCsv } from 'react-icons/gr'

import useMininumBilling from '@hook/parametrization/use-mininum-billing'
import useTools from '@hook/shared/use-tools'

import { ILayoutToolsExportAction } from '@base/@types/components/Layout/Tools'
const ActionExcelMininumBillingParameterExport: FC<ILayoutToolsExportAction> =
  () => {
    const { isDisabled } = useTools()
    const { exportData } = useMininumBilling()
    return (
      <MenuItem
        p="2px 12px"
        fontSize="sm"
        bgColor="white"
        _hover={{ bg: 'gray.400' }}
        isDisabled={isDisabled}
        onClick={exportData}
        icon={<GrDocumentCsv />}
      >
        Exportar para Tabela
      </MenuItem>
    )
  }

export default ActionExcelMininumBillingParameterExport
